import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  incidentNameIcon: {
    position: "absolute",
    left: 4,
    top: 8,
    width: 24,
    height: 24,
    padding: "5px 5px",
    textAlign: "center",
    color: "white",
  },
}));

export default useStyles;
